// extracted by mini-css-extract-plugin
export default {"react-select__placeholder":"SelectInput_react-select__placeholder__hWYAN"};